import { Button as MuiButton, ButtonProps as MuiButtonProps } from "@mui/material";
import { SxProps, Theme } from '@mui/material/styles';
import { FC } from 'react';

interface ButtonProps extends MuiButtonProps { sx?: SxProps<Theme> }

const Button: FC<ButtonProps> = ({ children, sx = [], ...props }) => {
  return (
    <MuiButton
      {...props}
      variant='outlined'
      sx={[
        {
          borderImage: 'linear-gradient(to right, #931216, #E20B23, #FF8230) 1 !important',
          border: '2px solid',
          letterSpacing: '0.1em',
          fontSize: '14px',
          padding: '10px, 20px',
          fontWeight: 500,
          color: 'black',
          backgroundColor: 'white',
          minWidth: 'fit-content',
          '&:hover': {
            border: '2px solid',
            backgroundColor: 'white'
          }
        },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}>
      {children}
    </MuiButton>
  )
};

export default Button;